import { store } from 'redux/store';

const getRequestInProgressStore = () => (store.getState() as any).api.requestsInProgress;

interface requestInProgress extends types.redux.api.requestInProgress.requestInProgress {}

export const isRequestInProgress = (requestInProgress: requestInProgress): undefined | requestInProgress => {
	const requests = getRequestInProgressStore();
	return requests.find((r: requestInProgress) => {
		return (
			r.url === requestInProgress.url &&
			r.payloadHash === requestInProgress.payloadHash &&
			r.method === requestInProgress.method
		);
	});
};
